module.exports = __webpack_public_path__ + "static/logoHostdime-a775d01abbbaf37c2b8c7046f30a959c.svg";